import React from "react";
import TransferenceTypesContainer from "components/containers/TransferenceTypes/TransferenceTypesContainer";


function TransferenceTypes(){
  return(
     <TransferenceTypesContainer/>
  )
}

export default TransferenceTypes;
